export default __webpack_public_path__ + "static/media/bg-vid.6db19bfd.mp4";